import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';
import { LsHelperService } from 'src/app/core/services/ls-helper.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { TransactionService } from '../services/transaction.service';

@Injectable({
	providedIn: 'root'
})
export class TransactionSupDocsService extends BaseProvider {
	mode: any = 'list';
	processId: any = 0;
	itemToEdit: any;
	canManageDocs = false;
	constructor(
		public globals: GlobalsService,
		public http: HttpClient,
		public ls: LsHelperService,
		private authService: AuthService,
		private transactionService: TransactionService,
	) {
		super();

		this.baseUrl = 'userProcessSupplementaryDocument';
	}

	getDocs() {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + 'userProcessDocument/userProcessId/' + this.processId;

			this.http.get(
				this.url
			)
				.subscribe(
					(data: any) => {
						if (this.page === 1) {
							this.list = data.Data;
						} else {
							this.pushItems(data.Data);
						}

						resolve(data);
					},
					err => { reject(err); }
				);
		});
	}

	newGetDocs() {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + 'userProcessDocument/userProcessId/' + this.processId;

			this.http.get(
				this.url
			)
				.subscribe(
					(data: any) => {
						if (this.page === 1) {
							this.list = data.Data;
						} else {
							this.pushItems(data.Data);
						}

						resolve(data);
					},
					err => { reject(err); }
				);
		});
	}

	createDoc(params) {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl;

			this.http
				.post(
					this.url,
					params
				)
				.subscribe(
					(data: any) => {
						resolve(data);
					},
					err => { reject(err); }
				);
		});
	}

	update(data) {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + '/' + data.Id;

			this.http
				.put(
					this.url,
					data
				)
				.subscribe(
					(resp: any) => {
						this.updateItem(data);

						resolve(resp);
					},
					err => { reject(err); }
				);
		});
	}

	delete(params) {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl +
				'/process/' + params.UserProcessId +
				'/doc/' + params.Id;

			this.http
				.delete(
					this.url
				)
				.subscribe(
					(data: any) => {
						resolve(data);
					},
					err => { reject(err); }
				);
		});
	}

	canEdit() {
		// User has 'can manage documents' policy
		// Transaction is not finished

		const hasPolicy = false;
		const transactionIsFinalized = true;

		// hasPolicy = this.authService.hasPolicyBool("CanManageDocuments");

		return (!this.transactionService.itemToEdit.IsFinalized
			&&
			(this.transactionService.itemToEdit.AssignedToCurrentUser
				||
				this.transactionService.itemToEdit.CreatedByCurrentUser));
	}

	canView() {
		// User has 'can view documents' policy

		let hasPolicy = false;

		hasPolicy = this.authService.hasPolicyBool('CanViewDocuments');

		return hasPolicy;
	}
	canManage() {
		// User has 'can view documents' policy

		let hasPolicy = false;

		hasPolicy = this.authService.hasPolicyBool('CanManageDocuments');
		this.canManageDocs = hasPolicy;
		return hasPolicy;
	}
}
